
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAuth from '../../../hooks/useAuth';

const Edit = () => {
  const { id } = useParams();
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { mainStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  useSetMenu(mainStore.RoleMenuType, mainStore.RoleMenuNo);
  const schema = yup.object({
    name: yup
    .string()
    .required(t('requiredField'))
    .max(256, t('maxLength', { max: 256 })),
  });

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const { notFound, updateData } = useEditData(axiosPrivate, "/Roles", id, setValue, navigate);

//  const onSubmit = data => updateData(data);
const onSubmit = data => {
  updateData(data);
};

  const goToList = () => {
    navigate("/Role/List");
  };

  if (notFound) {
    return <div className="not-found-myDiv">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>{t("pageNotFoundTitle")}</h1>
          <p>{t("noDataWithIdMessage")}</p>
          <button onClick={goToList} className="btn btn-primary">
            {t("goTo") + " " + t("list") + " " + t("roles")}
          </button>
        </div>
      </div>
    </div>;
  }

  return (
    <FormLayout title={t("roleEditTitle")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
      <FormInput label="roleName" name="name"  register={register} errors={errors} disabled={id==1}/>
      <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
    </FormLayout>
  );
};

export default observer(Edit);